// @flow

import Model from "app/models/Model";

export default class Folder extends Model {
    id: number;
    name: string;
    video_count: Number;

    normalize() {
        this.normalizeInt("video_count");
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Folder.js